import { __require as requireObjectDefineProperty } from './node_modules-core-js-internals-object-define-property.js';
import { __require as requireHasOwnProperty } from './node_modules-core-js-internals-has-own-property.js';
import { __require as requireWellKnownSymbol } from './node_modules-core-js-internals-well-known-symbol.js';

var setToStringTag;
var hasRequiredSetToStringTag;

function requireSetToStringTag () {
	if (hasRequiredSetToStringTag) return setToStringTag;
	hasRequiredSetToStringTag = 1;
	var defineProperty = requireObjectDefineProperty().f;
	var hasOwn = requireHasOwnProperty();
	var wellKnownSymbol = requireWellKnownSymbol();

	var TO_STRING_TAG = wellKnownSymbol('toStringTag');

	setToStringTag = function (target, TAG, STATIC) {
	  if (target && !STATIC) target = target.prototype;
	  if (target && !hasOwn(target, TO_STRING_TAG)) {
	    defineProperty(target, TO_STRING_TAG, { configurable: true, value: TAG });
	  }
	};
	return setToStringTag;
}

export { requireSetToStringTag as __require };
//# sourceMappingURL=node_modules-core-js-internals-set-to-string-tag.js.map
